var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('i',{staticClass:"icon-close gjw-iconfont gjw-icon-close",on:{"click":_vm.close}}),_c('component-detail',{ref:"detail"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }